interface NamedItem {
  name: string;
}

const SearchFunctionGetListFromCharAndArray = <T extends NamedItem>(
  char: string,
  array: T[]
): T[] => {
  return array.filter((item) => item.name.toLowerCase().includes(char.toLowerCase()));
};

export default SearchFunctionGetListFromCharAndArray;
